import { Pause } from "@educaplay/core/Icons/Pause";
import { Play } from './PlayIcon';
import IconButton from '../IconButton';

export default function PlayPauseButton({ onClick, playing }) {
    const Icon = playing ? Pause : Play;

    return (
        <IconButton
            Icon={Icon}
            onClick={onClick}
            lectormsg="play"
        />
    )
}
